// 標準的なボタンの大きさ
export const buttonWidth = 220;

// 日時選択の幅
export const dateTimePickerWidth = 200;
